<mat-form-field appearance="fill" style="margin-top: -23px;"  [ngStyle]="disablePointerEvent === true && {
  'pointer-events':'none'}">
  <input #selectRef class="customFont"
    type="text"    
    matInput
    [matAutocomplete]="auto" #trigger="matAutocompleteTrigger" 
    [formControl]="ddControl"   (keyup) = "onkeyPress($event)" (click)="openPanel($event, trigger)"
  />
  <span matSuffix *ngIf="selectRef.value && disablePointerEvent === false" (click)="clearText()"><i  class="fas fa-times"></i></span>
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <mat-option class="customFont"
    *ngFor="let item of filteredValues | async"
    [value]="selectedValues"
  >
    <div (click)="optionClicked($event, item)">
      <mat-checkbox
        [checked]="selectedValues.indexOf(item) > -1"
        (change)="toggleSelection(item)"
        (click)="$event.stopPropagation()"
      >
		{{item}}
      </mat-checkbox>
    </div>
  </mat-option>
</mat-autocomplete>
